import React, { useContext, useState, useEffect } from 'react';
import AppContext from '../../../App/AppContext';
import { Grid, Button, InputLabel, FormHelperText } from '@material-ui/core';
import { getBranchById, addBranch, updateBranch } from '../../../Core/Service/branch-screen-service';
import { TextBox } from '../../../Core/FormInput';
import { getInvoiceBranchByID } from '../../../Core/Service/admin-Invoice_Branch-service';

const BranchModal = ({ id, branchName, branchCode, onClose }) => {
    const [state, setState] = useState({
        shortName: '',
        branchCode: branchCode || '',
        name: branchName || '',
        address1: '',
        address2: '',
        address3: '',
        town: '',
        county: '',
        country: '',
        postcode: '',
        phone: '',
        branchFax: ''
    });

    const [errors, setErrors] = useState({});

    const { showToast } = useContext(AppContext);

    useEffect(() => {
        if (id) {
            fetchBranch();
        }
    }, [id]);

    const fetchBranch = async () => {
        try {
            let res = await getInvoiceBranchByID(id);
            if (res.success && res.data) {
                const data = res.data.branches.table[0];
                setState((st) => ({
                    ...st,
                    shortName: data.branchShortName || '',
                    branchCode: data.branchCode || '',
                    name: data.branchName || '',
                    address1: data.branchAddressLine1 || '',
                    address2: data.branchAddressLine2 || '',
                    address3: data.branchAddressLine3 || '',
                    town: data.branchTown || '',
                    county: data.branchCounty || '',
                    country: data.branchCountry || '',
                    postcode: data.branchPostCode || '',
                    phone: data.branchPhone || '',
                    branchFax: data.branchFax || ''
                }));
            }
        } catch (error) {
            console.error(error);
        }
    };

    const fieldChange = (event) => {
        const { name, value } = event.target;
        setState((st) => ({
            ...st,
            [name]: value
        }));
        // Clear error on change
        if (errors[name]) {
            setErrors((st) => ({
                ...st,
                [name]: ''
            }));
        }
    };

    const validate = () => {
        let tempErrors = {};
        tempErrors.shortName = state.shortName ? '' : 'Field is required.';
        tempErrors.branchCode = state.branchCode ? '' : 'Field is required.';
        tempErrors.name = state.name ? '' : 'Field is required.';
        // tempErrors.phone = state.phone ? '' : 'Field is required.';
        // tempErrors.branchFax = state.branchFax ? '' : 'Field is required.';
        tempErrors.address1 = state.address1 ? '' : 'Field is required.';
        // tempErrors.address2 = state.address2 ? '' : 'Field is required.';
        // tempErrors.address3 = state.address3 ? '' : 'Field is required.';
        tempErrors.town = state.town ? '' : 'Field is required.';
        // tempErrors.county = state.county ? '' : 'Field is required.';
        // tempErrors.country = state.country ? '' : 'Field is required.';
        tempErrors.postcode = state.postcode ? '' : 'Field is required.';

        setErrors(tempErrors);
        return Object.values(tempErrors).every((x) => x === '');
    };

    const handleSave = async () => {
        if (!validate()) {
            showToast('Please fill all required fields', 'error');
            return;
        }

        const payload = {
            id: id || null,
            ...state
        };

        let res;
        if (id) {
            res = await updateBranch(payload);
        } else {
            res = await addBranch(payload);
        }

        if (res && res.success) {
            showToast('Branch saved successfully');
            onClose && onClose(true);
        } else {
            showToast('Error saving branch');
        }
    };

    return (
        <div>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={12} md={6}>
                    <InputLabel shrink required error>
                        Name
                    </InputLabel>
                    <TextBox value={state.name} name="name" onChange={fieldChange} error={!!errors.name} />
                    <FormHelperText error>{errors.name}</FormHelperText>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink required error>
                        Short Name
                    </InputLabel>
                    <TextBox value={state.shortName} name="shortName" onChange={fieldChange} error={!!errors.shortName} />
                    <FormHelperText error>{errors.shortName}</FormHelperText>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink required error>
                        Branch Code
                    </InputLabel>
                    <TextBox value={state.branchCode} name="branchCode" onChange={fieldChange} error={!!errors.branchCode} />
                    <FormHelperText error>{errors.branchCode}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={8} md={8}>
                    <InputLabel shrink required error>
                        Address 1
                    </InputLabel>
                    <TextBox value={state.address1} name="address1" onChange={fieldChange} error={!!errors.address1} />
                    <FormHelperText error>{errors.address1}</FormHelperText>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                    <InputLabel shrink required error>
                        Postcode
                    </InputLabel>
                    <TextBox value={state.postcode} name="postcode" onChange={fieldChange} error={!!errors.postcode} />
                    <FormHelperText error>{errors.postcode}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                    <InputLabel shrink>Address 2</InputLabel>
                    <TextBox value={state.address2} name="address2" onChange={fieldChange} error={!!errors.address2} />
                    <FormHelperText error>{errors.address2}</FormHelperText>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <InputLabel shrink>Address 3</InputLabel>
                    <TextBox value={state.address3} name="address3" onChange={fieldChange} error={!!errors.address3} />
                    <FormHelperText error>{errors.address3}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4} md={4}>
                    <InputLabel shrink required error>
                        Town
                    </InputLabel>
                    <TextBox value={state.town} name="town" onChange={fieldChange} error={!!errors.town} />
                    <FormHelperText error>{errors.town}</FormHelperText>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                    <InputLabel shrink>County</InputLabel>
                    <TextBox value={state.county} name="county" onChange={fieldChange} error={!!errors.county} />
                    <FormHelperText error>{errors.county}</FormHelperText>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                    <InputLabel shrink>Country</InputLabel>
                    <TextBox value={state.country} name="country" onChange={fieldChange} error={!!errors.country} />
                    <FormHelperText error>{errors.country}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                    <InputLabel shrink>Phone</InputLabel>
                    <TextBox value={state.phone} name="phone" onChange={fieldChange} error={!!errors.phone} />
                    <FormHelperText error>{errors.phone}</FormHelperText>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <InputLabel shrink>Branch Fax</InputLabel>
                    <TextBox value={state.branchFax} name="branchFax" onChange={fieldChange} error={!!errors.branchFax} />
                    <FormHelperText error>{errors.branchFax}</FormHelperText>
                </Grid>

                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10, marginBottom: 10 }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12}>
                            <Button variant="contained" color="secondary" onClick={handleSave} fullWidth>
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};
export default BranchModal;
